import React, { useState, useEffect } from "react";
import "./OrderHistory.css";
import {
  sendMessage,
  registerMatchedTradesHandler,
} from "../services/websocket";

const OrderHistory = ({
  activeTrades = [],
  cancelledTrades = [],
  onCancelOrder,
}) => {
  const [filter, setFilter] = useState("active"); // 'active', 'cancelled', 'matched'
  const [matchedTrades, setMatchedTrades] = useState([]);

  useEffect(() => {
    // Register handler for matched trades
    const unregisterHandler = registerMatchedTradesHandler((trades) => {
      console.log("Received matched trades:", trades);
      setMatchedTrades(trades || []);
    });

    // Clean up on component unmount
    return () => {
      unregisterHandler();
    };
  }, []);

  // Request matched trades when the tab is selected
  useEffect(() => {
    if (filter === "matched") {
      console.log("Requesting matched trades data");
      sendMessage({ command: "matched_trades" });
    }
  }, [filter]);

  useEffect(() => {
    sendMessage({ command: "matched_trades" });
  }, []);

  // Combine and filter trades based on selected filter
  const getFilteredTrades = () => {
    switch (filter) {
      case "active":
        return activeTrades;
      case "cancelled":
        return cancelledTrades;
      case "matched":
        return matchedTrades;
      default:
        return [...activeTrades, ...cancelledTrades, ...matchedTrades];
    }
  };

  const filteredTrades = getFilteredTrades();

  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  return (
    <div className="order-history">
      <h2 className="order-history-title">Order History</h2>

      <div className="filter-tabs">
        <button
          className={`filter-tab ${filter === "active" ? "active" : ""}`}
          onClick={() => setFilter("active")}>
          Active
        </button>
        <button
          className={`filter-tab ${filter === "cancelled" ? "active" : ""}`}
          onClick={() => setFilter("cancelled")}>
          Cancelled
        </button>
        <button
          className={`filter-tab ${filter === "matched" ? "active" : ""}`}
          onClick={() => setFilter("matched")}>
          Matched Trades
        </button>
      </div>

      <div className="orders-list">
        {filteredTrades.length === 0 ? (
          <div className="no-orders">No trades to display</div>
        ) : (
          filteredTrades.map((trade) => (
            <div key={trade.id} className={`order-item ${trade.status}`}>
              <div className="order-header">
                <span className={`order-side ${trade.side}`}>
                  {trade.side === "buy" ? "Buy" : "Sell"}
                </span>
                <span className="order-contract">{trade.contractId || trade.symbol}</span>
                <span className="order-time">
                  {formatTime(trade.timestamp)}
                </span>
              </div>

              <div className="order-details">
                <div className="order-info">
                  <div className="info-row">
                    <span className="info-label">Symbol:</span>
                    <span className="info-value">
                      {(trade.symbol || trade.contractId || "").toUpperCase()}
                    </span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Price:</span>
                    <span className="info-value">
                      ${Number(trade.price).toFixed(2)}
                    </span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Quantity:</span>
                    <span className="info-value">{trade.quantity}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Status:</span>
                    <span className={`info-value status-${trade.status}`}>
                      {trade.status.charAt(0).toUpperCase() +
                        trade.status.slice(1)}
                    </span>
                  </div>
                </div>

                {trade.status === "active" && onCancelOrder && (
                  <button
                    className="cancel-btn"
                    onClick={() => onCancelOrder(trade.id)}>
                    Cancel
                  </button>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default OrderHistory;
